import request from '@/utils/request'

//  新增驿站
export const addOrUpdateStore = (formData) => {
    return request.post('/store', formData)
}

//  修改驿站
export const editOrUpdateStore = (updateData) => {
    return request.put('/store', updateData)
}

//  查询驿站
export const storeList = (pageData, formData) => {
    return request.get(`/store/${pageData.page}/${pageData.pageSize}`, {params:{name:formData.name}})
}

// 跨租户查询驿站
export const storeAllList = (pageData, formData) => {
    return request.get(`/store/ignoreTenant/${pageData.page}/${pageData.pageSize}`, {params:{name:formData.name}})
}

//  查询驿站详情
export const storeDetail = (id) => {
    return request.get(`/store/${id}`)
}

//  删除驿站
export const storeDelete = (id) => {
    return request.delete(`/store/${id}`)
}